import { ButtonHTMLAttributes, FunctionComponent } from 'react';

export enum ButtonStyle {
	Action = 'mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-cogvio-900 text-white text-base font-medium ' +
		'transition duration-200 ease-in-out hover:bg-cogvioBlue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm',
	Disabled = 'mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-gray-400 text-white text-base font-medium ' +
		'transition duration-200 ease-in-out sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm cursor-not-allowed',
	Cancel = 'mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-base font-medium text-gray-700 ' +
		'transition duration-200 ease-in-out hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm',
	Destroy = 'mt-3 w-full inline-flex justify-center rounded-md border border-red-700 px-4 py-2 bg-red-700 text-base font-medium text-white ' +
		'transition duration-200 ease-in-out hover:bg-red-600 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm',
	Link = 'px-4 py-2 text-sm font-medium text-cogvio-700 transition duration-200 ease-in-out underline hover:no-underline',
}

type ButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'style'> & { readonly style?: ButtonStyle };

export const Button: FunctionComponent<ButtonProps> = ({ children, style = ButtonStyle.Action, ...props }) => (
	<button {...props} className={style.valueOf()}>
		{children}
	</button>
);
